module.exports = __webpack_public_path__ + "static/media/ai.75b0f4a8.svg";